interface RedirectionResponse {
	found: boolean;
	redirect_url?: string;
	status_code?: number;
	message?: string;
}

// Track if this is the first page load
let isFirstLoad = true;

export default defineNuxtRouteMiddleware(async (to, from) => {
	const currentUrl = to.fullPath;

	// Skip non-page requests
	if (
		currentUrl.startsWith('/api/') ||
		currentUrl.startsWith('/favicon.ico') ||
		currentUrl.startsWith('/_') ||
		currentUrl.startsWith('/__')
	) {
		return; // Skip silently for these requests
	}

	// Only trigger redirection on page landings, not within-app navigation
	if (process.client) {
		// Check if this is a page landing
		const isPageLanding = isFirstLoad || !from;

		// Skip if it's within-app navigation
		if (!isPageLanding) {
			return;
		}

		// Mark that we've processed the first load
		isFirstLoad = false;
	}

	try {
		// Get store ID from the current store context
		const siteConfig = useSiteConfig();

		// Check if site config is available and properly loaded
		if (!siteConfig || !siteConfig.store || !siteConfig.store.id) {
			// Skip silently on initial load when config isn't ready yet
			return;
		}

		const storeId = siteConfig.store.id.toString();

		// Call the server API to check for redirections
		const path = to.path.substring(1); // Remove leading slash

		// Handle root path - use 'root' as the path for the root route
		const apiPath = path || 'root';

		try {
			const response = await $fetch<RedirectionResponse>(
				`/api/redirection/${apiPath}?store=${storeId}`,
				{
					timeout: 1000,
				},
			);

			if (response && response.found) {
				return navigateTo(response.redirect_url!, {
					redirectCode: response.status_code,
				});
			}
		} catch (apiError: unknown) {
			console.warn('⚠️ Redirection API call failed (soft failure):', apiError);
		}
	} catch (error) {
		console.warn('⚠️ Redirection middleware error (soft failure):', error);
	}
});
